import type { ReactNode } from 'react';

export const symbol_notification_multiple: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-24 0-42-18t-18-42v-504q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v504h535q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q657.75-80 645-80H110Zm740-180v-338L573-412q-15 11-33 11t-33-11L230-598v338h620Zm-620 60q-24 0-42-18t-18-42v-392q0-19.22 10-36.61T204-715l283-173q11-7 23.5-4.5t19.09 13.5q7.41 11 4.41 23.5T520-836L239-661l301 199 300-198q11.41-8 23.21-7.5Q875-667 886-662t17.5 15q6.5 10 6.5 24v363q0 24-18 42t-42 18H230Zm302-441 163-163q9-9 21-8.5t21 9.5q9 9 9 21.5t-9 21.5L553-576q-9 9-21 9t-21-9l-74-74q-9-9-8.5-21.5T438-693q9-9 21.5-9t21.5 9l51 52ZM230-260h620-620Z"
		/>
	</svg>
);
